<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <v-btn
          @click="openRechargeModal"
          color="primary"
          elevation="0"
        >
          <v-icon left>mdi-plus</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('create.label.recharge') }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <v-tabs v-model="tab" color="realEstate">
      <v-tab class="mw-200" to="recharge">
        {{ $t('recharge.rechargeList') }}
      </v-tab>
      <v-tab class="mw-200" to="charge">
        {{ $t('charge.title.chargeList') }}
      </v-tab>
    </v-tabs>

    <v-divider class="mb-4 grey lighten-3" />

    <RechargeList v-if="tab === 'recharge'" />
    <ChargeList v-if="tab === 'charge'" />
  </div>
</template>

<script>
import RechargeList from '@/components/recharge/RechargeList'
import RechargeCreate from '@/components/recharge/RechargeCreate'
import ChargeList from '@/views/charge/components/ChargeList'

export default {
  name: 'Recharge',

  components: {
    RechargeList,
    RechargeCreate,
    ChargeList,
  },

  methods: {
    openRechargeModal() {
      const modal =  this.$root.$children[0].$refs?.createRecharge?.$refs?.createModal
      modal.dialog = true
    },
  },

  data() {
    return {
      tab: null,
    }
  },
}
</script>
